import {ILabels} from "@/apps/StudentExchangeInformationColumnWidget/models/config-viewmodel";

export interface StudentExchangeInformationColumnWidgetWidget {
    labels: ILabels,
    isModalOpen: Boolean,
    offset: Number
}

export class WidgetState implements StudentExchangeInformationColumnWidgetWidget {
    labels: ILabels = {
        informationSectionTitle: '',
        informationSectionText: ''
    }
    isModalOpen: Boolean = false
    offset: number = 0
}
